import { css } from '@emotion/css'
import React from 'react'
import { AssessGradeBadge } from '../badge'
import { ApplicationModule } from './api/get-application-modules'

export const gradeCellBadgeTestId = 'grade-cell-badge-test-id'

export function gradeColumnCellRenderer({
  isLoading,
  rowData: { letterGrade }
}: {
  isLoading: boolean
  rowData: ApplicationModule
}) {
  return (
    <div
      className={css`
        padding: 0 2px;
        margin: 10px;
        width: 24px;
      `}
    >
      <AssessGradeBadge
        dataTestId={gradeCellBadgeTestId}
        isAssessSupported={true}
        value={isLoading ? 'UNKNOWN' : letterGrade}
      />
    </div>
  )
}
